import { IBrowserInfo } from '../reducers';

// action enums
export enum BrowserManagerActionsEnum {
  SET_DEVICE_ID = '[Browser Manager] SET_DEVICE_ID',
  SET_COOKIE = '[Browser Manager] SET_COOKIE',
  SET_COOKIES = '[Browser Manager] SET_COOKIES',
  REMOVE_COOKIES = '[Browser Manager] REMOVE_COOKIES',
  SET_BROWSER_DATA = '[Browser Manager] SET_BROWSER_DATA',
}

// action payload interfaces
export interface IKey {
  key: string;
}

export interface IRemoveCookie {
  keys: string[];
  domain: string;
  path: string;
}

export interface IKeyValue extends IKey {
  value: string | number | boolean;
}

export interface IDeviceId {
  deviceId: string;
}

export interface ICookies {
  cookies: IKeyValue[];
}

export interface IBrowserData {
  browserData: IBrowserInfo;
}

// action definitions
export interface SetDeviceId {
  type: BrowserManagerActionsEnum.SET_DEVICE_ID;
  payload: IDeviceId;
}

export interface SetCookie {
  type: BrowserManagerActionsEnum.SET_COOKIE;
  payload: IKeyValue;
}

export interface SetCookies {
  type: BrowserManagerActionsEnum.SET_COOKIES;
  payload: ICookies;
}

export interface RemoveCookies {
  type: BrowserManagerActionsEnum.REMOVE_COOKIES;
  payload: IRemoveCookie;
}

export interface SetBrowserData {
  type: BrowserManagerActionsEnum.SET_BROWSER_DATA;
  payload: IBrowserData;
}

export const setDeviceId = (deviceId: string): SetDeviceId => {
  return {
    type: BrowserManagerActionsEnum.SET_DEVICE_ID,
    payload: {
      deviceId,
    },
  };
};

export const setCookie = (key: string, value: string): SetCookie => {
  return {
    type: BrowserManagerActionsEnum.SET_COOKIE,
    payload: {
      key,
      value,
    },
  };
};

export const setCookies = (cookies: IKeyValue[]): SetCookies => {
  return {
    type: BrowserManagerActionsEnum.SET_COOKIES,
    payload: {
      cookies,
    },
  };
};

export const removeCookies = (
  keys: string[],
  path?: string,
  domain?: string
): RemoveCookies => {
  return {
    type: BrowserManagerActionsEnum.REMOVE_COOKIES,
    payload: {
      keys,
      path,
      domain,
    },
  };
};

export const setBrowserData = (browserData: IBrowserInfo): SetBrowserData => {
  return {
    type: BrowserManagerActionsEnum.SET_BROWSER_DATA,
    payload: {
      browserData,
    },
  };
};
